import { call, put, takeEvery, select } from 'redux-saga/effects'

import api from '~/services/api'
import {
	loadingMessage,
	successMessage,
	errorMessage,
} from '~/services/messager'

import {
	answerRequest,
	answerModify,
	answerSuccess,
	answerFailure,
	setResetAnswer,
} from '.'

import { setResetQuestion } from '~/states/modules/question'
import { selectVisibleAnswers } from './selectors'

export default function* rootSaga() {
	yield takeEvery(answerRequest, answerSaga)
	yield takeEvery(answerModify, answerModifySaga)
}

function* answerSaga({ payload }) {
	const { history, draft } = payload

	loadingMessage({
		content: 'Nossos robôs estão trabalhando para gerar seu documento',
		updateKey: 'answer',
	})

	const {
		answer,
		modelId,
		title,
		parent,
		pages,
		visible,
		uploadedFile,
		contextAi,
		session,
	} = yield select((state) => {
		const {
			answer,
			question: {
				modelId,
				documentTitle,
				parent,
				data: pages,
				visible,
				uploadedFile,
				contextAi,
			},
			analytics: { session },
		} = state
		return {
			answer,
			modelId,
			title: documentTitle,
			parent,
			pages,
			visible,
			uploadedFile,
			contextAi,
			session,
		}
	})

	const endDate = new Date()
	const duration = endDate - session.startDate

	const finishedSession = {
		type: session.type,
		start: session.startDate,
		end: endDate,
		duration,
	}

	try {
		const { data } = yield call(api.post, '/documents/', {
			document_template: modelId,
			parent: parent,
			title,
			visible,
			draft,
			variables: selectVisibleAnswers(answer.data, pages, visible),
			uploadedFile,
			contextAi,
			session: finishedSession,
		})
		yield put(answerSuccess(data))
		successMessage({
			content: 'Documento criado com sucesso!',
			updateKey: 'answer',
		})

		history.push(`/documents/${data.id}`)
		yield put(setResetAnswer())
		yield put(setResetQuestion())
	} catch (error) {
		console.log('Error during document registration', error)
		yield put(answerFailure(error))
		errorMessage({
			content: 'A criação do documento falhou',
			updateKey: 'answer',
		})
	}
}

function* answerModifySaga({ payload }) {
	const { id, history, draft } = payload

	loadingMessage({
		content: 'Nossos robôs estão trabalhando para gerar seu documento',
		updateKey: 'answer',
	})

	const { answer, pages, visible, session } = yield select((state) => {
		const {
			answer,
			question: { modelId, title, parent, data: pages, visible },
			analytics: { session },
		} = state
		return { answer, modelId, title, parent, pages, visible, session }
	})

	const analytics = yield select((state) => state.analytics)
	const stateSession = analytics?.session

	const endDate = new Date()
	const duration = stateSession?.startDate
		? endDate - stateSession.startDate
		: 0

	const finishedSession = {
		type: session?.type || 'unknown',
		start: session?.startDate || stateSession?.startDate || endDate,
		end: endDate,
		duration,
	}

	try {
		const { data } = yield call(api.post, `documents/${id}/modify`, {
			variables: selectVisibleAnswers(answer.data, pages, visible),
			visible,
			draft,
			session: finishedSession,
		})

		yield put(answerSuccess(data))
		successMessage({
			content: 'Edição do documento feito com sucesso!',
			updateKey: 'answer',
		})
		history.push(`/documents/${id}`)
		yield put(setResetAnswer())
		yield put(setResetQuestion())
	} catch (error) {
		console.log(error)
		yield put(answerFailure(error))
		errorMessage({
			content: 'A edição de documento falhou',
			updateKey: 'answer',
		})
	}
}
